import React from 'react';
import { type InlineEditorHints } from '@bbk/ui/inline-editing';
import { type RestSpeechBubble1Modal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import ModalPerson from './sections/person';
import SimpleModalTitle from './sections/simple-title';

type Props = Pick<RestSpeechBubble1Modal['requires'], 'info' | 'person'> & {
  modal: RestSpeechBubble1Modal;
  actions: React.ReactNode;
};
const RenderSpeechBubble: React.FC<Props> = (props) => {
  const {
    modal: { id },
    info,
    person,
    actions,
  } = props;

  return (
    <div className="speech-bubble-1">
      <div className="SBContainer">
        <div className="left" data-part="person">
          <ModalPerson person={person} />
        </div>
        <div className="right">
          <div className="quote" data-part="description">
            <SimpleModalTitle>
              <CustomerHtml value={info.title} />
            </SimpleModalTitle>
            <div className="details">
              <CustomerHtml value={info.details} />
            </div>
            {info.question && <div className="question">{info.question}</div>}
            <div className="arrow-down" />
          </div>
          <div className="action">{actions}</div>
        </div>
      </div>
    </div>
  );
};

const SpeechBubble = Object.assign(RenderSpeechBubble, {
  editorHints: {
    description: {
      path: ['requires', 'info'],
      control: 'group',
      selector: '[data-part="description"]',
      placement: 'right',
      fields: [
        {
          path: ['title'],
          control: 'richText',
          options: {
            formatting: false,
          },
        },
        {
          path: ['details'],
          control: 'richText',
        },
        {
          path: ['question'],
          control: 'text',
        },
      ],
    },
    person: {
      path: ['requires', 'person'],
      control: 'group',
      selector: '[data-part="person"]',
      placement: 'bottom',
      fields: [
        {
          path: ['avatar'],
          control: 'image',
          options: {
            helpLabel: 'Recommended size: 250x250px; < 100kB',
          },
        },
        {
          path: ['name'],
          control: 'text',
          label: 'Name',
        },
        {
          path: ['title'],
          control: 'text',
          label: 'Title',
        },
        {
          path: ['preposition'],
          control: 'text',
          label: 'Preposition',
        },
        {
          path: ['organization'],
          control: 'text',
          label: 'Company',
        },
      ],
    },
    primaryAction: {
      path: ['requires', 'forwards'],
      control: 'ctaAppearance',
      selector: '[data-part="primary-action"]',
      placement: 'top-end',
      label: 'Action',
    },
    otherActions: {
      path: ['requires', 'other_actions'],
      control: 'ctaAppearance',
      selector: '[data-part="other-action"]',
      placement: 'top-end',
      label: 'Action',
      indexAttribute: 'data-action-index',
    },
  } satisfies InlineEditorHints,
});
export default SpeechBubble;
